'use client'

import { type ComponentProps, type ReactNode, useEffect, useState } from 'react'

type VisuallyHiddenProps = {
  children: ReactNode
  className?: string
} & ComponentProps<'span'>

const VisuallyHidden = ({
  children,
  className,
  ...props
}: VisuallyHiddenProps) => {
  const [forceShow, setForceShow] = useState(false)

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      const handleKeyDown = (ev: KeyboardEvent) => {
        if (ev.metaKey) {
          setForceShow(true)
        }
      }

      const handleKeyUp = () => {
        setForceShow(false)
      }

      document.addEventListener('keydown', handleKeyDown)
      document.addEventListener('keyup', handleKeyUp)

      return () => {
        document.removeEventListener('keydown', handleKeyDown)
        document.removeEventListener('keyup', handleKeyUp)
      }
    }
  }, [])

  if (forceShow) {
    return children
  }

  return (
    <span className={`sr-only ${className || ''}`} {...props}>
      {children}
    </span>
  )
}

export { VisuallyHidden }
